import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const HowItWorksContent = styled.div`
    flex-direction: column;
    row-gap: 16px;
`;

export const TicketsInfo = styled.div`
    flex-direction: column;
    row-gap: 12px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        row-gap: 8px;
    }
`;

export const BoldText = styled.span`
    ${FONTS.MediumXS};
    white-space: nowrap;

    @media (min-width: ${wideBreakpoints.mobile}) {
        ${FONTS.MediumS};
    }
`;

export const UpShiftedContent = styled.div`
    flex-direction: column;
    row-gap: 16px;
    margin-top: -12px;
`;

export const Text = styled.p`
    color: ${COLORS.TextInfo};
    ${FONTS.S};
    white-space: break-spaces;
`;

export const ChatLink = styled.span`
    ${FONTS.MediumS};
    color: ${COLORS.Link};
    cursor: pointer;
`;
